<dl>
  @if (!!extraInfo.start_date) {
    <dt>StartDate</dt>
    <dd>{{extraInfo.start_date | date:'mediumDate' }}</dd>
  }
  @if (!!extraInfo.end_date) {
    <dt>EndDate</dt>
    <dd>{{extraInfo.end_date | date:'mediumDate' }}</dd>
  }
  @if (!!extraInfo.offer || !!extraInfo.offer_label) {
    <dt>Offer</dt>
    <dd><strong>{{extraInfo.offer_label}}</strong> {{extraInfo.offer}}</dd>
  }
  @if (!!extraInfo.offer_terms) {
    <dt>OfferTerms</dt>
    <dd>{{extraInfo.offer_terms}}</dd>
  }
  @if (!!extraInfo.external_url) {
    <dt>ExternalUrl</dt>
    <dd>{{extraInfo.external_url}}</dd>
  }
</dl>
